import React, { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import './App.css';
import UIRoutes from './UIRoutes';
import { Routes, Route, useNavigate } from 'react-router-dom';
import LoginPage from './Login/LoginPage';
import axiosInstance from './axios/axios';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Function to check if token is valid
    const checkTokenValidity = async () => {
      const token = localStorage.getItem('auth_token');
      if (token) {
        try {
          const response = await axiosInstance.get('/users/checkToken')

          if (response.status === 200) {
            // Token is valid
            setIsAuthenticated(true);
          }
        } catch (error) {
          // Token is not valid or expired
          localStorage.removeItem("Previlege");
          localStorage.removeItem("User");
          localStorage.removeItem("auth_token");
          localStorage.removeItem("User_Details");
          setIsAuthenticated(false);
          navigate('/'); // Redirect to login page if token is invalid
        }
      } else {
        // No token found
        localStorage.removeItem("Previlege");
        localStorage.removeItem("User");
        localStorage.removeItem("auth_token");
        localStorage.removeItem("User_Details");
        setIsAuthenticated(false);
        navigate('/'); // Redirect to login page if no token
      }
    };

    checkTokenValidity();
  }, [navigate]);

  const handleLogin = () => {
    setIsAuthenticated(true);
    localStorage.setItem('isAuthenticated', 'true');
    navigate('/dashboard'); // Redirect to dashboard after successful login
  };

  return (
    <div className="app">
      {isAuthenticated ? (
        <>
          <Sidebar />
          <div className="content">
            <Header />
            <div className="main-content">
              <UIRoutes />
            </div>
          </div>
        </>
      ) : (
        <Routes>
          <Route path="/" element={<LoginPage onLogin={handleLogin} />} />
        </Routes>
      )}
    </div>
  );
}

export default App;
